import useTranslation from "next-translate/useTranslation"
import { useState } from "react"
import { Card, CardBody, CardHeader, Tooltip } from "reactstrap"

import TranslatedHtml from "@components/common/TranslatedHtml"

/**
 * This component shows an info to the user, if he is not a member in any project.
 * Used in the project dashboard of the user.
 */
const EmptyProjectCard: React.FC = () => {
  const { t } = useTranslation("common")

  const [tooltipOpen, setTooltipOpen] = useState(false)
  const toggleTooltip = () => {
    setTooltipOpen(!tooltipOpen)
  }

  return <><Card
    className="project-card project-card--empty"
    id="emptyProjectCard"
    data-testid="emptyprojectcard"
  >
    <CardHeader>
      <h3>{t("page.projects.index.newProject.header")}</h3>
    </CardHeader>

    <CardBody>
      <TranslatedHtml content="page.projects.index.newProject.body" />
    </CardBody>
  </Card>
    <Tooltip target={"emptyProjectCard"} toggle={toggleTooltip} isOpen={tooltipOpen}>
      {t("goto.marketplace")}
    </Tooltip>
  </>

}

export default EmptyProjectCard
